import type { Organization } from "../admin"
import type { StationType } from "../stations"

// Base types used across all domains
export interface BaseModel {
  id: string
  created_at?: string
  updated_at?: string
}

// Generic page/pagination type
export interface Page<T> {
  items: T[]
  total: number
  pages: number
  page: number
  size: number
  stations_online: number
  station_types?: StationType[]
  orgs?: Organization[]
}

export const emptyPage = <T>(): Page<T> => ({
  items: [],
  total: 0,
  pages: 0,
  page: 0,
  size: 0,
  stations_online: 0,
  station_types: [],
  orgs: [],
})

// Common enums and types
export enum ActivityState {
  IDLE = 0, // Ready but not doing anything
  ACTIVE = 1,
  PENDING = 2,
  ERROR = 3,
}

export type Direction = "pan_right" | "pan_left" | "tilt_up" | "tilt_down"

export interface TimeRange {
  from: number // timestamp
  to: number // timestamp
  label: string
}

// SSE event type
export interface EventSEE {
  event: string
  data: any
}

export type ValueOf<T> = T[keyof T]
